import React from "react";
import { Check } from "lucide-react";
import { ABOUT_PRIMARY, ABOUT_SECONDARY } from "../data/mock";
import { AboutCubes, NetworkDiagram } from "./Illustrations";
import { useReveal } from "./useReveal";

const About = () => {
  const r1 = useReveal();
  const r2 = useReveal();

  return (
    <section id="about" className="py-24 bg-white">
      <div className="aaa-container">
        {/* primary block */}
        <div ref={r1} className={`aaa-fade-up grid md:grid-cols-2 gap-14 items-center ${r1 ? "" : ""}`}>
          <div className="order-2 md:order-1 flex justify-center">
            <AboutCubes className="w-72 md:w-80" />
          </div>
          <div className="order-1 md:order-2">
            <p className="aaa-eyebrow mb-3">
              <span className="inline-block w-8 h-px bg-[#ef6b6b] align-middle mr-2" />
              {ABOUT_PRIMARY.eyebrow}
            </p>
            <h2 className="font-display text-3xl md:text-4xl font-bold leading-snug">
              {ABOUT_PRIMARY.title}
            </h2>
            <p className="mt-5 leading-relaxed max-w-lg">{ABOUT_PRIMARY.body}</p>
            <ul className="mt-6 space-y-3">
              {ABOUT_PRIMARY.bullets.map((b) => (
                <li key={b} className="flex items-center gap-3">
                  <span className="w-2 h-2 rounded-full bg-[#ef6b6b]" />
                  <span className="text-[#4a4860]">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* secondary block */}
        <div ref={r2} className="aaa-fade-up grid md:grid-cols-2 gap-14 items-center mt-28">
          <div>
            <p className="aaa-eyebrow mb-3">
              <span className="inline-block w-8 h-px bg-[#ef6b6b] align-middle mr-2" />
              {ABOUT_SECONDARY.eyebrow}
            </p>
            <h2 className="font-display text-3xl md:text-4xl font-bold leading-snug">
              {ABOUT_SECONDARY.title}
            </h2>
            <p className="mt-5 leading-relaxed max-w-lg">{ABOUT_SECONDARY.body}</p>
            <ul className="mt-6 space-y-4">
              {ABOUT_SECONDARY.features.map((f) => (
                <li key={f.title} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 rounded-full bg-[#f2e7f0] flex items-center justify-center shrink-0">
                    <Check size={13} className="text-[#7a4fa3]" />
                  </span>
                  <p className="text-[#4a4860]">
                    <span className="font-semibold text-[#3d3b54]">{f.title}</span>{" "}
                    <span className="text-[#6f6d84]">{f.desc}</span>
                  </p>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex justify-center">
            <NetworkDiagram nodes={ABOUT_SECONDARY.nodes} className="w-80 md:w-96" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
